// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2s8oc","header":"Messages_header__3mDTh"};